




import { WidgetInstance } from 'friendly-challenge';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class CaptchaClient extends Vue {
	protected friendlyCaptchaWidget: WidgetInstance | null = null;

	protected friendlyCaptchaWidgetReady: boolean = false;

	protected solution: string | null = null;

	@Prop({
		type: String,
		default: 'focus'
	})
	protected startMode: 'focus' | 'auto' | 'none' = 'focus';

	protected mounted(): void {
		this.initializeWidget();
	}

	protected initializeWidget(): void {
		if (!this.captchaEnabled) {
			this.emitSolution('');
			return;
		}

		type WidgetInstanceOptions = NonNullable<ConstructorParameters<typeof WidgetInstance>[1]>;
		type Language = WidgetInstanceOptions['language'];

		/* eslint-disable @typescript-eslint/camelcase */
		const language: Language = {
			text_init: this.i18n.captchaTextInit,
			text_ready: this.i18n.captchaTextReady,
			button_start: this.i18n.captchaButtonStart,
			text_fetching: this.i18n.captchaTextFetching,
			text_solving: this.i18n.captchaTextSolving,
			text_completed: this.i18n.captchaTextCompleted,
			text_expired: this.i18n.captchaTextExpired,
			button_restart: this.i18n.captchaButtonRestart,
			text_error: this.i18n.captchaTextError,
			button_retry: this.i18n.captchaButtonRetry,
			text_fetch_error: this.i18n.captchaTextFetchError
		};
		/* eslint-enable @typescript-eslint/camelcase */

		this.friendlyCaptchaWidget = new WidgetInstance(this.$el as HTMLDivElement, {
			puzzleEndpoint: `${this.global.env.FRIENDLYCAPTCHA_API_BASE_URL}puzzle`,
			solutionFieldName: 'captcha-solution' as any,
			sitekey: this.global.env.FRIENDLYCAPTCHA_SITE_KEY,
			startMode: this.startMode,
			language,
			readyCallback: () => {
				this.friendlyCaptchaWidgetReady = true;
			},
			doneCallback: (solution: any) => {
				this.solution = solution;
				this.emitSolution(solution);
			}
		});
	}

	public solve(): void {
		if (this.solution) {
			this.emitSolution(this.solution);
			return;
		}

		if (!this.captchaEnabled) {
			this.emitSolution('');
			return;
		}

		if (!this.friendlyCaptchaWidget || !this.friendlyCaptchaWidgetReady) {
			throw new Error('Captcha widget not initialized - cannot solve puzzle');
		}

		this.friendlyCaptchaWidget.start();
	}

	public reset(): void {
		this.solution = null;

		if (this.friendlyCaptchaWidget) {
			this.friendlyCaptchaWidget.reset();
		}
	}

	protected emitSolution(solution: string): void {
		this.$emit('solved', solution);
	}

	protected get captchaEnabled(): boolean {
		return this.global.env.CAPTCHA_ENABLED;
	}
}
